import AutocompleteField from "../../../Form/AutocompleteField";
import { LANGUAGE_OPTIONS_META } from "../../../../utils/catalogs/languageOptions";

const SelectLanguagesMetaForm = ({
  name,
  control,
  errors,
  sx = {},
  disabled = false,
}) => {
  return (
    <AutocompleteField
      name={name}
      control={control}
      errors={errors}
      options={LANGUAGE_OPTIONS_META}
      doTranslate={true}
      fullWidth
      multiple={true}
      sx={sx}
      disabled={disabled}
    />
  );
};

export default SelectLanguagesMetaForm;
